// tk-ticker — fills the track with copies of the item group so a -50% translate loops seamlessly.
// Clones are aria-hidden + inert so screen readers and keyboard users meet each item once.
class TkTicker extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.group = this.querySelector('[data-group]');
    if (!this.track || !this.group) return;

    // WCAG 2.2.2: moving content needs a pause control.
    this.pauseButton = this.querySelector('[data-pause]');
    this.onPause = () => this.setPaused(!this.hasAttribute('data-paused'));
    this.pauseButton?.addEventListener('click', this.onPause);

    this.resizeObserver = new ResizeObserver(() => this.fill());
    this.resizeObserver.observe(this);
    this.fill();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.pauseButton?.removeEventListener('click', this.onPause);
  }

  setPaused(paused) {
    this.toggleAttribute('data-paused', paused);
    if (!this.pauseButton) return;
    const { labelPause, labelPlay } = this.pauseButton.dataset;
    this.pauseButton.setAttribute('aria-label', paused ? labelPlay : labelPause);
  }

  fill() {
    const groupWidth = this.group.getBoundingClientRect().width;
    if (!groupWidth) return;
    // Need (copies * groupWidth) >= viewport width, and an even group count for the -50% loop.
    const copies = Math.max(1, Math.ceil(this.clientWidth / groupWidth));
    const wanted = copies * 2;
    if (this.track.children.length === wanted) return;

    for (const clone of this.track.querySelectorAll('[data-clone]')) clone.remove();
    for (let i = 1; i < wanted; i++) {
      const clone = this.group.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.inert = true;
      for (const el of clone.querySelectorAll('[id]')) el.removeAttribute('id');
      for (const el of clone.querySelectorAll('[data-shopify-editor-block]')) {
        el.removeAttribute('data-shopify-editor-block');
      }
      this.track.append(clone);
    }
    this.setAttribute('data-ready', '');
  }
}

if (!customElements.get('tk-ticker')) customElements.define('tk-ticker', TkTicker);
